import script from "./PanelInicio.vue?vue&type=script&setup=true&lang=js"
export * from "./PanelInicio.vue?vue&type=script&setup=true&lang=js"

import "./PanelInicio.vue?vue&type=style&index=0&id=42af76bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42af76bf"]])

export default __exports__